<h1 class="accent-background-element">Add new User</h1>

<mat-dialog-content class="higher">


  <form [formGroup]="form" class="input-form">
    <h3>User Role</h3>
    <mat-chip-listbox aria-label="Role selection" formControlName="role">
      <mat-chip-option color="accent"  #roleChip2 color="accent"
      [value]="UserRolesEnum.hcp">{{UserRolesEnum.hcp}}</mat-chip-option>
      <mat-chip-option onclick="this.blur()" #roleChip  color="accent"
      [value]="UserRolesEnum.ent">{{UserRolesEnum.ent}}</mat-chip-option>
      <mat-chip-option onclick="this.blur()" #roleChip3 color="accent"
      [value]="UserRolesEnum.dal">{{UserRolesEnum.dal}}</mat-chip-option>
    </mat-chip-listbox>
    <h3>First Name</h3>
    <div>
      <input placeholder="First Name" formControlName="firstName" class="mat-body languageChiptext-input"
        [ngClass]="{'warn-border-element':((form.controls['firstName'].dirty || form.controls['firstName'].touched) && form.controls['firstName'].invalid )}">
  </div>
  <h3>Last Name</h3>
  <div>
    <input placeholder="Last Name" formControlName="lastName" class="mat-body languageChiptext-input"
      [ngClass]="{'warn-border-element':((form.controls['lastName'].dirty || form.controls['lastName'].touched) && form.controls['lastName'].invalid )}">
</div>
<h3>E-mail</h3>
<div>
  <input type="email" placeholder="Email" formControlName="email" class="mat-body languageChiptext-input"
    [ngClass]="{'warn-border-element':((form.controls['email'].dirty || form.controls['email'].touched) && form.controls['email'].invalid )}">
</div>
<h3>Country</h3>
<mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
  <mat-select formControlName="country" class='accent-border-element mat-body' placeholder="Country">
    @for (countryID of CountriesIDs | keyvalue; track countryID) {
      <mat-option class='accent-hover-element'  [value]='countryID.value'>{{this.getFullCountryNameById(countryID.value)}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
@if ( !isEnt() && !isDal()) {
  <div class="conditional-field">
    <h3>Clinic</h3>
    <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
      <mat-select #clinicSelect formControlName="clinic" class='accent-border-element mat-body'
        placeholder="Clinic">
        <input matInput placeholder="Filter by Clinic ID, Clinic Name or Clinic Address" #filterClinic
          class="accent-border-element filter-clinic" autofocus>
          @for (clinic of clinicList; track clinic) {
            <div>
              @if (isStartsWithSubstring(clinic.clinicId,filterClinic.value)
                ||isStartsWithSubstring(clinic.clinicName,filterClinic.value )
                ||isStartsWithSubstring(clinic.addressLine1,filterClinic.value)
                ||isStartsWithSubstring(clinic.addressLine2,filterClinic.value)) {
                <mat-option class='accent-hover-element' [value]='clinic'>
                  {{[clinic.clinicId, clinic.clinicName, clinic.addressLine1,clinic.addressLine2].join(', ')}}
                </mat-option>
              }
            </div>
          }
          @if (clinicList.length<1) {
            <div>
              <mat-option>No clinics found for selected country.</mat-option>
            </div>
          }
        </mat-select>
      </mat-form-field>
      <div class="button-container">
        <p>Clinics selected: {{getClinicsAmount()}} / {{clinicList.length}}<mat-icon svgIcon="tooltip"
          class="secondary-contrast-icon" [matTooltip]="getClinicsIds()"
        matTooltipPosition="right"></mat-icon></p>
        <button id="selectClinicsButton" [disabled]="isSelectClinicsButtonDiasabledSubject|async"
          mat-raised-button color="accent" (click)="showSelectClinicsDialog()">Select
        more clinics</button>
      </div>
    </div>
  }
  @if ( isEnt()) {
    <div class="conditional-field">
      <h3>ENT Office</h3>
      <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
        <mat-select #clinicSelect formControlName="entOffice" class='accent-border-element mat-body'
          placeholder="ENT Office">
          <input matInput placeholder="Filter by Office ID, Office Name or Office Address" #filterOffice
            class="accent-border-element filter-clinic" autofocus>
            @for (office of officeList; track office) {
              <div>
                @if (isStartsWithSubstring(office.entOfficeId,filterOffice.value)
                  ||isStartsWithSubstring(office.entOfficeName,filterOffice.value)
                  ||isStartsWithSubstring(office.addressLine1,filterOffice.value)
                  ||isStartsWithSubstring(office.addressLine2,filterOffice.value)) {
                  <mat-option class='accent-hover-element' [value]='office'>
                    {{[office.entOfficeId, office.entOfficeName,
                    office.addressLine1,office.addressLine2].join(',')}}
                  </mat-option>
                }
              </div>
            }
            @if (officeList.length<1) {
              <div>
                <mat-option>No offices found for selected country.</mat-option>
              </div>
            }
          </mat-select></mat-form-field>
        </div>
      }

      <h3>Language</h3>
      <mat-chip-listbox aria-label="Language selection" selectable formControlName="language">
        <mat-chip-option onclick="this.blur()" #languageChip
        color="accent" [value]="LanguagesEnum.en">{{LanguagesEnum.en.toUpperCase()}}</mat-chip-option>
        <mat-chip-option onclick="this.blur()" #languageChip4
        color="accent" [value]="LanguagesEnum.de">{{LanguagesEnum.de.toUpperCase()}}</mat-chip-option>
        <mat-chip-option onclick="this.blur()" #languageChip5
        color="accent" [value]="LanguagesEnum.es">{{LanguagesEnum.es.toUpperCase()}}</mat-chip-option>
        <mat-chip-option onclick="this.blur()" #languageChip6
        color="accent" [value]="LanguagesEnum.fr">{{LanguagesEnum.fr.toUpperCase()}}</mat-chip-option>
        <mat-chip-option onclick="this.blur()" #languageChip2
        color="accent" [value]="LanguagesEnum.it">{{LanguagesEnum.it.toUpperCase()}}</mat-chip-option>
        <mat-chip-option onclick="this.blur()" #languageChip3
        color="accent" [value]="LanguagesEnum.nl">{{LanguagesEnum.nl.toUpperCase()}}</mat-chip-option>
      </mat-chip-listbox>

      @if (  !isDal()) {
        <div class="conditional-field flex">
          @if ( !isEnt()) {
            <div class="flex">
              <p><b>Shop Manager:&nbsp;</b>
            </p>
            <div> <mat-slide-toggle formControlName="shopAdminAccess"></mat-slide-toggle></div>
          </div>
        }
        @if ( !isEnt()) {
          <div class="flex">
            <p><b>Country Manager:&nbsp;</b>
          </p>
          <div> <mat-slide-toggle formControlName="countryShopsAccess"></mat-slide-toggle></div>
        </div>
      }
      @if ( !isEnt()) {
        <div class="flex">
          <p><b>Patient Manager:&nbsp;</b>
        </p>
        <div> <mat-slide-toggle formControlName="patientManagerAccess"></mat-slide-toggle></div>
      </div>
    }
    <div class="flex">
      <p><b>Advanced Dashboard User:&nbsp;</b>
    </p>
    <div> <mat-slide-toggle formControlName="advancedMode"></mat-slide-toggle></div>
  </div>
</div>
}
</form>



</mat-dialog-content>

<mat-dialog-actions>

  <button mat-raised-button color="accent" [disabled]="isDisabledButton()" (keyup.enter)="onSubmit()"
  (click)="onSubmit()">Continue</button>
</mat-dialog-actions>